<template>
  <el-container class="admin">
    <el-header class="admin__header">FM52.0 管理后台</el-header>
    <el-container class="admin__container">
      <el-aside width="160px">
        <AdminMenu></AdminMenu>
      </el-aside>
      <el-main>
        <div class="bar">
          <el-date-picker
            v-model="dateRangeValue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
           <el-button class="search-btn" plain @click="onSearch">搜索</el-button>
        </div>
        <div class="daily-container">
          <Daily
            v-for="(item) in dateList"
            :key="item"
            :date="item"
            :list="tableData[item]"
          ></Daily>
        </div>
        <PlaylistImg></PlaylistImg>
        <!-- <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          :total="100">
        </el-pagination> -->
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { Container, Header, Aside, Main, Button, Row, Col, Pagination, DatePicker } from 'element-ui'
import AdminMenu from './AdminMenu'
import Daily from './Daily'
import PlaylistImg from './PlaylistImg'
import api from '@/api'
import dayjs from 'dayjs'
import { getDateListByDateRange } from '@/utils'

export default {
  name: 'Admin',
  components: {
    [Container.name]: Container,
    [Header.name]: Header,
    [Aside.name]: Aside,
    [Main.name]: Main,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Pagination.name]: Pagination,
    [DatePicker.name]: DatePicker,
    AdminMenu,
    Daily,
    PlaylistImg
  },
  data () {
    return {
      dateList: [],
      tableData: {},
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dateRangeValue: '',
    }
  },
  methods: {
    onSearch() {
      if (this.dateRangeValue) {
        // const date1 = dateList[0]
        // const date2 = dateList[1]
        const dateRange = this.dateRangeValue.map((item) => {
          return dayjs(item).format('YYYY-MM-DD').toString()
        })
        // console.log(dateRange)
        this.getList(dateRange)
      }
    },
    async getList(dateRange) {
      const res = await api.getOrderList(dateRange)
      if (res.code === 0) {
        const tableData = {}
        res.data.list.forEach((item) => {
          if (!tableData[item.date]) {
            tableData[item.date] = []
          }
          tableData[item.date].push(item)
        })
        // console.log(tableData)
        // let dateList = Object.keys(tableData)
        // dateList.sort((a, b) => b.localeCompare(a))
        // this.dateList = dateList
        this.tableData = tableData
        if (dateRange) {
          this.dateList = getDateListByDateRange(dateRange).sort((a, b) => b.localeCompare(a))
        } else {
          this.dateList = [dayjs().format('YYYY-MM-DD').toString()]
        }
        // console.log(this.tableData)
        // console.log(this.dateList)
      } else {
        this.$toast(res.message)
      }
    },
    gotoLogin() {
      this.$router.replace({
        name: 'login',
        query: {
          redirect: 'admin'
        }
      })
    }
  },
  async created () {
    const res = await api.getCurrentUser()
    if (res.code === 0) {
      if (res.data.is_admin) {
        this.getList()
      } else {
        this.gotoLogin()
      }
    } else {
      this.gotoLogin()
    }
  },
  mounted() {
    // bus.$on('createCanvasImg', (data) => {
    //   console.log(data)
    // })
  }
}
</script>

<style lang="less" scoped>
.admin {
  height: 100vh;
  &__header {
    padding-top: 20px;
    border-bottom: 1px solid #f1f1f1;
    font-size: 20px;
    font-weight: bold;
  }
  &__container {
    overflow: auto;
  }
}
.bar {
  display: flex;
}
.search-btn {
  margin-left: 10px;
}
.daily-container {
  margin-top: 20px;
  // height: 500px;
  // overflow: auto;
}
.pagination {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/index.vue